import React, { useState, useEffect } from 'react';
import { Link } from 'react-router';
import errorCover from '../images/errorCover.jpg';

export function SpeakerIcon({ className, size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <g clipPath="url(#clip0_speaker)">
        <path d="M21 12.8333C21 13.6149 21 14.3849 21 15.1666C22.4 15.1666 24.22 15.1666 25.6667 15.1666C25.6667 14.3849 25.6667 13.6149 25.6667 12.8333C24.22 12.8333 22.4 12.8333 21 12.8333Z" fill="currentColor" />
        <path d="M18.6665 20.5451C19.7865 21.3734 21.2448 22.4701 22.3998 23.3334C22.8665 22.7151 23.3332 22.0851 23.7998 21.4667C22.6448 20.6034 21.1865 19.5067 20.0665 18.6667C19.5998 19.2967 19.1332 19.9267 18.6665 20.5451Z" fill="currentColor" />
        <path d="M23.7998 6.53341C23.3332 5.91508 22.8665 5.28508 22.3998 4.66675C21.2448 5.53008 19.7865 6.62675 18.6665 7.46675C19.1332 8.08508 19.5998 8.71508 20.0665 9.33341C21.1865 8.49341 22.6448 7.40841 23.7998 6.53341Z" fill="currentColor" />
        <path d="M4.66683 10.5C3.3835 10.5 2.3335 11.55 2.3335 12.8333V15.1667C2.3335 16.45 3.3835 17.5 4.66683 17.5H5.8335V22.1667H8.16683V17.5H9.3335L15.1668 21V7L9.3335 10.5H4.66683ZM10.5352 12.495L12.8335 11.1183V16.8817L10.5352 15.505L9.97516 15.1667H9.3335H4.66683V12.8333H9.3335H9.97516L10.5352 12.495Z" fill="currentColor" />
        <path d="M18.0835 13.9999C18.0835 12.4482 17.4068 11.0482 16.3335 10.0916V17.8966C17.4068 16.9516 18.0835 15.5516 18.0835 13.9999Z" fill="currentColor" />
        <path opacity="0.3" d="M10.5348 12.4951L12.8332 11.1184V16.8817L10.5348 15.5051L9.97484 15.1667H9.33317H4.6665V12.8334H9.33317H9.97484L10.5348 12.4951Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_speaker">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

const AVATAR_COLORS = [
  '#f97316', // orange
  '#ec4899', // pink
  '#22c55e', // green
  '#3b82f6', // blue
  '#a855f7', // purple
  '#eab308', // amber
  '#06b6d4', // cyan
];

export function getUserLabel(user) {
  return user.displayName || user.username || '';
}

export function getInitials(label, fallback) {
  const base = (label || '').trim() || String(fallback || '');
  if (!base) return '?';
  const parts = base.split(/\s+/);
  if (parts.length === 1) {
    return parts[0].slice(0, 1).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function getAvatarColorKey(user) {
  const label = getUserLabel(user);
  return label || String(user.id || '');
}

export function getAvatarColor(user) {
  const key = getAvatarColorKey(user);
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
}

function SearchLightGameCard({ game, currentUserId }) {
  const {
    id,
    coverPortrait,
    cover,
    likedNumber = 0,
    likeCount,
    likedUsers = [],
  } = game;

  const count = likeCount != null ? likeCount : likedNumber;
  const initialLiked =
    !!currentUserId && (likedUsers || []).some((u) => String(u.id) === String(currentUserId));
  const [liked, setLiked] = useState(initialLiked);
  const imageSrc = coverPortrait || cover || errorCover;

  useEffect(() => {
    const nextLiked =
      !!currentUserId && (likedUsers || []).some((u) => String(u.id) === String(currentUserId));
    setLiked(nextLiked);
  }, [currentUserId, likedUsers]);


  return (
    <article className="SearchLightCard">
      <div className="SearchLightCard__cover-wrap">
        <Link
          to={{
            pathname: `/searchlight/game/${id}`,
            state: { searchLightGame: game },
          }}
          className="SearchLightCard__link"
        >
          <img
            src={imageSrc}
            alt="Game cover"
            className="SearchLightCard__cover-img"
            onError={(e) => {
              e.target.src = errorCover;
            }}
          />
        </Link>
        <div className="SearchLightCard__body">
          <div className="SearchLightCard__row">
            <button
              type="button"
              className={`SearchLightCard__like ${liked ? 'is-liked' : ''}`}
              aria-label={liked ? '取消点赞' : '点赞'}
            >
              <SpeakerIcon size={24} />
            </button>
            <span className="SearchLightCard__count">{count}</span>
            <div className="SearchLightCard__avatars" aria-label="点赞用户">
              {(likedUsers || []).slice(0, 5).map((u) => {
                const label = getUserLabel(u);
                const initials = getInitials(label, u.id);
                const color = getAvatarColor(u);
                return (
                  <div
                    key={u.id}
                    className="SearchLightCard__avatar"
                    style={{ backgroundColor: color }}
                    title={label}
                  >
                    {initials}
                  </div>
                );
              })}
              {Array.isArray(likedUsers) && likedUsers.length > 5 && (
                <div className="SearchLightCard__avatar SearchLightCard__avatar--more">
                  +{likedUsers.length - 5}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default SearchLightGameCard;
